export default __webpack_public_path__ + "static/jo-manhattan-banner-c218e72fee04d90548a95b722922ac09.jpg";